import axios, {AxiosResponse} from 'axios'
import {ID} from '@/_metronic/helpers'
import {
  SupportQueryResponse,
} from './_models'

const BASE_URL = '/p2c/support'

export const getTickets = (query: string): Promise<SupportQueryResponse> => {
  return axios
    .get(`${BASE_URL}?${query}`)
    .then((d: AxiosResponse<SupportQueryResponse>) => {
      return d.data
    })
}

export const replyTicket = (ticketId: ID, message: string, closed: boolean): Promise<void> => {
  return axios
    .put(`${BASE_URL}/${ticketId}`, {
      message,
      closed
    })
    .then(() => {})
}
